import React, { useState } from "react";
import { useSelector } from "react-redux";

const useRole = () => {
  const role = useSelector((state) => state?.userInfo?.userInfo?.type);
  return {
    role,
    isSuperAdmin: role === "superadmin",
    isAdmin: role === "admin",
    isUser: role ? role === "user" : true,
    isDesigner: role === "designer",
    onlyAdmins: role === "admin" || role === "superadmin",
  };
};

export default useRole;
